// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Modal from '~/app/components/Modal';
import Button from '~/app/ui/Button';
import Icon from '@ff/ui/Icon';
import { S, DARK } from '~/app/ui/tokens';

type Props = {
  onSave: (iconClassName: ?string) => void,
  onClose: () => void,
  icons: Array<string>,
  classes: Object
};

function IconGallery({ classes, icons, onClose, onSave }: Props) {
  const actions = (
    <div className={classes.actions}>
      <Button onClick={onClose}>Cancel</Button>
    </div>
  );

  const grid = (
    <div className={classes.gridContainer}>
      <div className={classes.iconContainer}>
        <span
          className={classes.noIcon}
          onClick={() => onSave(null)}
        >no icon</span>
      </div>
      {icons.map((icon, i) => (
        <div className={classes.iconContainer} key={i}>
          <Icon
            name={icon}
            className={classes.displayIcons}
            fontSize="60px"
            onClick={() => onSave(icon)}
          />
        </div>
      ))}
    </div>
  );

  return (
    <Modal
      title={'Icon Gallery'}
      actions={actions}
      onClose={onClose}
      className={classes.container}
    >
      {grid}
    </Modal>
  );
}

const styles = {
  container: {
    width: '100%'
  },
  // The footer spreads its children; keep Cancel on the right.
  actions: {
    marginLeft: 'auto'
  },
  gridContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
  iconContainer: {
    marginTop: '20px',
    marginBottom: '20px',
    borderRadius: '5px',
    height: '90px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'hsl(0, 0%, 90%)',
    },
    [DARK]: { '&:hover': { backgroundColor: S.chromeHover } },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  displayIcons: {
    fontSize: '50px',
    padding: '20px',
    display: 'block',
    color: 'hsl(0, 0%, 20%)',
    [DARK]: { color: S.fg }
  },
  noIcon: {
    fontSize: '36px',
    padding: '20px',
    display: 'block',
    color: 'hsl(0, 0%, 20%)',
    [DARK]: { color: S.fg }
  }
};

export default injectSheet(styles)(IconGallery);
